import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Icons
import LeftClickIcon from "../../../assets/icons/configurationIcons/mouse-left-click.svg"
import RightClickIcon from "../../../assets/icons/configurationIcons/mouse-right-click.svg"
import selectEditIcon from '../../../assets/icons/configurationIcons/new-edit.svg'
import selectDeleteIcon from '../../../assets/icons/configurationIcons/new-delete.svg'
// import selectDeleteIcon from '../../../assets/icons/configurationIcons/sil.svg'
// import selectDeleteIcon from '../../../assets/icons/configurationIcons/editsvg'

// Import Css
import './Guide.css';

export default function Guide({ isClick, isShowSquareHighlight, isDrawArea, isScope, refresh }) {
    const [isConfiguration, setIsConfiguration] = useState(false)

    const { t } = useTranslation();
    const label = `CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.DCAPTURE.GUIDE.${isClick ? "CLICK." : isScope ? "SCOPE" : "SELECT."}`;

    useEffect(() => {
        setIsConfiguration(() => {
            if (isClick) {
                return !["none", ""].includes(document.querySelector(".hidden-dot")?.style?.display) ? true : false
            }
            return document.querySelector(".select-configuration")?.style?.display !== "none" ? true : false
        })
    }, [refresh])


    return (
        <div className="helper-container">
            <h2>Guide</h2>
            {isClick && !isScope ?
                <div className='info-container'>
                    {
                        isShowSquareHighlight ?
                            <>
                                <span className='info-span header-span'>{t(label + "AFTER-SQUIRE-HIGHLIGHTS.1")}</span>
                                <span className='info-span'>  <img src={LeftClickIcon} className='guide-icon' />{t(label + "AFTER-SQUIRE-HIGHLIGHTS.2")}</span>
                                <span className='info-span'><img src={RightClickIcon} className='guide-icon' /> {t(label + "AFTER-SQUIRE-HIGHLIGHTS.3")}</span>
                                <span className='info-span'> <img src={selectEditIcon} className='guide-icon' />{t(label + "AFTER-SQUIRE-HIGHLIGHTS.4")}</span>
                                <span className='info-span'> <img src={selectDeleteIcon} className='guide-icon' />{t(label + "AFTER-SQUIRE-HIGHLIGHTS.5")}</span>
                                <span className='info-span header-span last-header-span'>{t(label + "AFTER-SQUIRE-HIGHLIGHTS.6")}</span>
                                <span className='info-span'> <img src={LeftClickIcon} className='guide-icon' />{t(label + "AFTER-SQUIRE-HIGHLIGHTS.7")}</span>
                            </>
                            : isConfiguration
                                ? <span>{t(label + "CONFIGURE-MENU-OPEN")}</span>
                                : <span>{t(label + "BEFORE-SQUIRE-HIGHLIGHTS")}</span>
                    }
                </div>
                :
                <div>
                    {isScope && !isDrawArea ?
                        <span>{t(label)}</span>
                        :
                        isDrawArea ?
                            <span>{t(label + "AFTER-AREA-SELECTED")}</span>
                            :
                            isConfiguration
                                ? <span>{t(label + "BEFORE-NO-VARIABLE")}</span>
                                : <span>{t(label + "AFTER-SAVE")}</span>
                    }
                </div>
            }

            {/* <img className='guide-icon' src={LeftClickIcon} /> <span>Tıklayın</span> */}
            {/* <span>{t(label + `${actionName}.` + "AFTER-SQUIRE-HIGHLIGHTS")}</span> */}
        </div>
    );
}
